import { Link } from 'react-router-dom';
import { dramas } from '@/mocks/dramas';
import ScrollReveal from '@/components/base/ScrollReveal';

export default function HotDramas() {
  const hotDramas = dramas.filter((d) => d.featured || d.rating >= 9.0).slice(0, 8);

  return (
    <ScrollReveal>
      <section className="max-w-[1400px] mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="flex items-center justify-between mb-8">
          <div>
            <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-100">
              <i className="ri-fire-line text-accent-500 mr-2"></i>
              热播推荐
            </h2>
            <p className="text-sm text-foreground-500 mt-1">精选高分好剧，追剧不踩雷</p>
          </div>
          <Link
            to="/category/guochan"
            className="text-sm text-primary-500 hover:text-primary-400 transition-colors duration-200 flex items-center gap-1 cursor-pointer whitespace-nowrap"
          >
            查看更多 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 xl:grid-cols-6 gap-4">
          {hotDramas.map((drama, i) => (
            <Link
              key={drama.id}
              to={`/article/${drama.id}`}
              className="group cursor-pointer transition-all duration-500 hover:-translate-y-1"
              style={{ animationDelay: `${i * 50}ms` }}
            >
              <div className="relative rounded-lg overflow-hidden mb-3" style={{ aspectRatio: '2/3' }}>
                <img
                  src={drama.cover}
                  alt={drama.title}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                  loading="lazy"
                />
                <div className="absolute top-2 left-2">
                  <span className="bg-primary-500 text-background-950 text-xs font-bold px-2 py-0.5 rounded-md">
                    {drama.rating}
                  </span>
                </div>
                <div className="absolute top-2 right-2">
                  <span className={`text-xs px-2 py-0.5 rounded-md ${
                    drama.status === '更新中'
                      ? 'bg-accent-500/90 text-foreground-50'
                      : 'bg-background-900/70 text-foreground-300'
                  }`}>
                    {drama.status}
                  </span>
                </div>
                <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end justify-center pb-4">
                  <span className="text-sm text-foreground-50 bg-primary-500/90 px-4 py-1.5 rounded-full">
                    立即观看
                  </span>
                </div>
              </div>
              <h3 className="text-sm font-medium text-foreground-200 group-hover:text-primary-500 transition-colors duration-200 truncate">
                {drama.title}
              </h3>
              <p className="text-xs text-foreground-500 mt-1">
                {drama.actors.slice(0, 2).join(' / ')}
              </p>
            </Link>
          ))}
        </div>
      </section>
    </ScrollReveal>
  );
}